import { createBrowserRouter } from 'react-router-dom';
import App from './routes/App';

// Enable future flags for React Router
const router = createBrowserRouter([
  {
    path: '/*',
    element: <App />
  }
], {
  future: {
    // These are the correct flag names for React Router v6
    v7_normalizeFormMethod: true
  }
});

export default router;